import { Controller } from "@hotwired/stimulus"
import { SIDE_FILTER_SELECTOR, slugKey, checkedMediumKey } from "@/lib/Listing/MobileFilterHelpers.js"

export default class extends Controller {
  static values = { categoryMediums: Object }

  connect() {
    this.syncRadios()
  }

  selectCategory({ params: { category } }) {
    const mediums = this.categoryMediumsValue[category] ?? []

    this.#form.querySelectorAll('input[name="medium[]"]').forEach((input) => {
      input.checked = mediums.includes(input.value)
    })
  }

  syncRadios() {
    const form = this.#form
    if (!form) return

    const selected = checkedMediumKey(form)

    this.element.querySelectorAll("label[data-mobile-filter-categories-category-param]").forEach((label) => {
      const radio = label.querySelector('input[type="radio"]')
      if (!radio) return

      const name = label.dataset.mobileFilterCategoriesCategoryParam
      radio.checked = name === "All Art" ? selected === "" : slugKey(this.categoryMediumsValue[name] ?? []) === selected
    })
  }

  get #form() {
    return this.element.querySelector(SIDE_FILTER_SELECTOR)
  }
}
